var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { ConfigFieldControl } from '@sierralabs/core-ui';
import { useSiteContext } from '../../SiteContext';
import { LabeledEventTypes } from '../SiteEventPlugin';
const SiteEventEditDialog = (_a) => {
    var { open, component, supportedEventTypes, onCancel, onChange } = _a, props = __rest(_a, ["open", "component", "supportedEventTypes", "onCancel", "onChange"]);
    const { eventPlugins } = useSiteContext();
    const [eventConfig, setEventConfig] = useState(props.eventConfig || { eventType: 'onClick' });
    const plugin = useMemo(() => {
        if (eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.type) {
            return eventPlugins.find(p => p.type === (eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.type));
        }
    }, [eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.type, eventPlugins]);
    return (React.createElement(Dialog, { fullWidth: true, open: open, onClose: onCancel },
        React.createElement(DialogTitle, null, "Site Event Configuration"),
        React.createElement(DialogContent, null,
            React.createElement(ConfigFieldControl, null,
                React.createElement(TextField, { select: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Event Type', value: (eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.eventType) || 'onClick', onChange: event => setEventConfig(eventConfig => {
                        const eventType = event.target.value;
                        eventConfig = Object.assign(Object.assign({}, eventConfig), { eventType });
                        // remove plugin type and config
                        // if selected eventType conflicts with selected plugin type
                        const isInvalid = eventPlugins.some(plugin => {
                            return (plugin.type === eventConfig.type &&
                                !plugin.eventTypes.includes(eventType));
                        });
                        if (isInvalid) {
                            delete eventConfig.type;
                            delete eventConfig.config;
                        }
                        return eventConfig;
                    }) }, LabeledEventTypes.map(type => (React.createElement(MenuItem, { key: type.value, value: type.value }, type.label))))),
            React.createElement(ConfigFieldControl, null,
                React.createElement(TextField, { select: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Event Handler', value: (eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.type) || '', onChange: event => setEventConfig(Object.assign(Object.assign({}, eventConfig), { type: event.target.value })) }, eventPlugins
                    .filter(plugin => {
                    // only display plugins with matching eventType
                    return plugin.eventTypes.includes((eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.eventType) || 'onClick');
                })
                    .map(plugin => (React.createElement(MenuItem, { key: plugin.type, value: plugin.type }, plugin.name))))),
            plugin ? (!plugin.configurator ? (React.createElement(Alert, { severity: 'info' }, "No configuration available for this event.")) : (React.createElement(ConfigFieldControl, null, React.createElement(plugin.configurator, { config: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.config, onChange: config => {
                    setEventConfig(Object.assign(Object.assign({}, eventConfig), { config }));
                } })))) : eventConfig.type ? (React.createElement(Alert, { severity: 'error' },
                "Event \"", eventConfig === null || eventConfig === void 0 ? void 0 :
                eventConfig.type,
                "\" not found.")) : null),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: onCancel }, "Cancel"),
            React.createElement(Button, { variant: 'contained', color: 'primary', disabled: !eventConfig, onClick: () => {
                    if (eventConfig) {
                        onChange === null || onChange === void 0 ? void 0 : onChange(eventConfig);
                    }
                } }, "Save"))));
};
export default SiteEventEditDialog;
//# sourceMappingURL=SiteEventEditDialog.js.map